// Tenants list (picker landing)
export const CSP_LICENSE_TENANTS_LOADING = 'CSP_LICENSE_TENANTS_LOADING'
export const CSP_LICENSE_TENANTS_LOADED = 'CSP_LICENSE_TENANTS_LOADED'
export const CSP_LICENSE_TENANTS_FAILED = 'CSP_LICENSE_TENANTS_FAILED'

// Per-tenant detail
export const CSP_LICENSE_TENANT_DETAIL_LOADING = 'CSP_LICENSE_TENANT_DETAIL_LOADING'
export const CSP_LICENSE_TENANT_DETAIL_LOADED = 'CSP_LICENSE_TENANT_DETAIL_LOADED'
export const CSP_LICENSE_TENANT_DETAIL_FAILED = 'CSP_LICENSE_TENANT_DETAIL_FAILED'
export const CSP_LICENSE_TENANT_DETAIL_NOT_FOUND = 'CSP_LICENSE_TENANT_DETAIL_NOT_FOUND'
export const CSP_LICENSE_TENANT_DETAIL_CLEAR = 'CSP_LICENSE_TENANT_DETAIL_CLEAR'

// Per-tenant sync (manual trigger from the tenant detail page)
export const CSP_LICENSE_TENANT_SYNC_TRIGGERING = 'CSP_LICENSE_TENANT_SYNC_TRIGGERING'
export const CSP_LICENSE_TENANT_SYNC_TRIGGERED = 'CSP_LICENSE_TENANT_SYNC_TRIGGERED'
export const CSP_LICENSE_TENANT_SYNC_FAILED = 'CSP_LICENSE_TENANT_SYNC_FAILED'

// Settings (per-role thresholds)
export const CSP_LICENSE_SETTINGS_LOADING = 'CSP_LICENSE_SETTINGS_LOADING'
export const CSP_LICENSE_SETTINGS_LOADED = 'CSP_LICENSE_SETTINGS_LOADED'
export const CSP_LICENSE_SETTINGS_SAVING = 'CSP_LICENSE_SETTINGS_SAVING'
export const CSP_LICENSE_SETTINGS_SAVED = 'CSP_LICENSE_SETTINGS_SAVED'
export const CSP_LICENSE_SETTINGS_FAILED = 'CSP_LICENSE_SETTINGS_FAILED'

// Cart - client-side staging on the tenant detail page
export const CSP_LICENSE_CART_STAGE = 'CSP_LICENSE_CART_STAGE'
export const CSP_LICENSE_CART_REMOVE = 'CSP_LICENSE_CART_REMOVE'
export const CSP_LICENSE_CART_CLEAR = 'CSP_LICENSE_CART_CLEAR'

// Submit / retry / cancel / mark
export const CSP_LICENSE_REQUEST_SUBMITTING = 'CSP_LICENSE_REQUEST_SUBMITTING'
export const CSP_LICENSE_REQUEST_SUBMITTED = 'CSP_LICENSE_REQUEST_SUBMITTED'
export const CSP_LICENSE_REQUEST_REJECTED = 'CSP_LICENSE_REQUEST_REJECTED'
export const CSP_LICENSE_REQUEST_FAILED = 'CSP_LICENSE_REQUEST_FAILED'
export const CSP_LICENSE_REQUEST_LIFECYCLE_PENDING = 'CSP_LICENSE_REQUEST_LIFECYCLE_PENDING'
export const CSP_LICENSE_REQUEST_LIFECYCLE_DONE = 'CSP_LICENSE_REQUEST_LIFECYCLE_DONE'

// My Requests list / detail
export const CSP_LICENSE_MY_REQUESTS_LOADING = 'CSP_LICENSE_MY_REQUESTS_LOADING'
export const CSP_LICENSE_MY_REQUESTS_LOADED = 'CSP_LICENSE_MY_REQUESTS_LOADED'
export const CSP_LICENSE_MY_REQUESTS_FAILED = 'CSP_LICENSE_MY_REQUESTS_FAILED'

// Approvals queue (peer-approval surface for ITManager / SSE / Admin)
export const CSP_LICENSE_PENDING_APPROVALS_LOADING = 'CSP_LICENSE_PENDING_APPROVALS_LOADING'
export const CSP_LICENSE_PENDING_APPROVALS_LOADED = 'CSP_LICENSE_PENDING_APPROVALS_LOADED'
export const CSP_LICENSE_PENDING_APPROVALS_FAILED = 'CSP_LICENSE_PENDING_APPROVALS_FAILED'

// Activity Log — cross-tenant audit feed for Admin / Sales
export const CSP_LICENSE_AUDIT_LOG_LOADING = 'CSP_LICENSE_AUDIT_LOG_LOADING'
export const CSP_LICENSE_AUDIT_LOG_LOADED = 'CSP_LICENSE_AUDIT_LOG_LOADED'
export const CSP_LICENSE_AUDIT_LOG_FAILED = 'CSP_LICENSE_AUDIT_LOG_FAILED'

// Product curation
export const CSP_LICENSE_PRODUCTS_LOADING = 'CSP_LICENSE_PRODUCTS_LOADING'
export const CSP_LICENSE_PRODUCTS_LOADED = 'CSP_LICENSE_PRODUCTS_LOADED'
export const CSP_LICENSE_PRODUCTS_FAILED = 'CSP_LICENSE_PRODUCTS_FAILED'
export const CSP_LICENSE_PRODUCTS_MUTATING = 'CSP_LICENSE_PRODUCTS_MUTATING'
export const CSP_LICENSE_PRODUCTS_MUTATED = 'CSP_LICENSE_PRODUCTS_MUTATED'
